import {InfoDTO} from "../../types/utils/InfoDTO";
import React from "react";
import {Space} from "antd";
import moment from "moment";
import {createUseStyles} from "react-jss";
import {GlobalToken} from "antd/es/theme/interface";

const useStyle = createUseStyles<string, { deleted: boolean }, GlobalToken>({
    deleted: ({deleted}) => ({
        position: "relative",
        width: "max-content",
        overflow: "hidden",
        opacity: deleted ? 0.6 : 1,
        '&:after': {
            content: '""',
            position: "absolute",
            top: "50%",
            left: deleted ? 0 : "-100%",
            width: "100%",
            height: "2px",
            backgroundColor: "#757575",
            display: 'block',
            transition: ".2s ease-in left"
        }
    })
})

type PrintFooterProps = {
    producer: InfoDTO,
    expiration_date?: string,
    styleAsDeleted?: boolean
}

const PrintFooter: React.FC<PrintFooterProps> = ({producer, expiration_date, styleAsDeleted = false}) => {

    const classes = useStyle({deleted: styleAsDeleted})

    return (
        <Space direction='vertical'>
            <p className={classes.deleted}>{`"${producer.name.ru}"`}</p>
            <p className={classes.deleted}>{expiration_date ? `до ${moment(expiration_date).format("DD.MM.yyyy HH:mm")}` : ''}</p>
        </Space>
    )
}

export default PrintFooter